import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import PageSwiper from '@src/components/swiper/page-swiper';
import TopMenu from '@src/business-components/top-menu';
import Page from '../../components/page';
import KvPage from './components/kvPage';
import NewPage from './components/newPage';
import MechaPage from './components/mechaPage';
import MechaUnitPage from './components/mechaUnitPage';

import cx from 'classnames';
import FeaturePage from './components/featurePage';
import WorldPage from './components/worldPage';
import ContactWayPage from './components/contactWayPage';
import CommonFooter from '@src/business-components/common-footer';

import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import redirect from '@src/utils/redirect-if-mobile-accress';
const lang = getLanguageByPath();
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => {
    return new MainStore();
  });
  //console.log(store.pageSwiperStore.baseSwiperStore.activeIndex);

  const mainTab = () => {
    if (store.pageSwiperStore?.baseSwiperStore?.activeIndex < 7) {
      return (
        <div className={styles.mainTabBox}>
          <div className={styles.textColor}>
            <div className={styles.tabSubscript}>0{store.pageSwiperStore.baseSwiperStore.activeIndex + 1}/07</div>
            <div className={styles.tabIcon} />
            <div className={styles.tabScroll}>SCROLL</div>
          </div>
        </div>
      );
    }
  };

  return (
    <Page>
      <div className={cx(styles.mainRoot, 'page-main')}>
        <TopMenu store={store.topMenuStore} />
        {mainTab()}
        <PageSwiper store={store.pageSwiperStore}>
          <div className={styles.pageItem} data-name="首页">
            {store.kvPageStore.isActive && <KvPage store={store.kvPageStore} />}
          </div>
          <div className={styles.pageItem} data-name="新闻资讯">
            {store.newPageStore.isActive && <NewPage store={store.newPageStore} />}
          </div>
          <div className={styles.pageItem} data-name="机兵介绍-普通">
            {store.mechaPageStore.isActive && <MechaPage store={store.mechaPageStore} />}
          </div>
          <div className={styles.pageItem} data-name="机兵介绍-特装">
            {store.mechaUnitPageStore.isActive && <MechaUnitPage store={store.mechaUnitPageStore} />}
          </div>
          <div className={styles.pageItem} data-name="游戏特色">
            {store.featurePageStore.isActive && <FeaturePage store={store.featurePageStore} />}
          </div>
          <div className={styles.pageItem} data-name="世界观介绍">
            {store.worldPageStore.isActive && <WorldPage store={store.worldPageStore} />}
          </div>
          <div className={styles.pageItem} data-name="联系方式">
            {store.contactWayPageStore.isActive && <ContactWayPage store={store.contactWayPageStore} />}
          </div>
          <div className={cx(styles.pageItem, styles.footer)} data-name="footer">
            {/* <div className={styles.footerBox}>{lang === 'zh-Hant' ? <ZhHantFooter /> : <CommonFooter />}</div> */}
          </div>
        </PageSwiper>
        <div className={cx(styles.footerBox, store.pageSwiperStore.baseSwiperStore.activeIndex === 7 && styles.footerShow)}>
          <CommonFooter store={store.CommonFooterStore} />
        </div>
      </div>
    </Page>
  );
};

export default observer(Main);
